import { useQuery } from "@tanstack/react-query";
import { EmployeeService, NonEmailUserResponse } from "../../../../services/department-viags/employee-viags.service";

export const useNonEmailUsers = (groupEmails: string[]) => {
    return useQuery<NonEmailUserResponse[], Error>({
      queryKey: ['nonEmailUsers', groupEmails],
      queryFn: () => EmployeeService.getListNoneEmail(groupEmails),
      enabled: groupEmails.length > 0 // prevent call when array is empty
    });
  };